/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['../nls/StringResources'], function (stringResources) {
	return {
		'properties': {
			'effect.entry.line.type': {
				'tabName': stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'public': true,
				'displayPos': 0
			},
			'effect.entry.line.stagger': {
				'tabName':  stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'public': true,
				'displayPos': 1
			},
			'effect.entry.line.duration': {
				'tabName':  stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'label': stringResources.get('propAniRevealDuration'),
				'ariaLabel': stringResources.get('propAniRevealDuration'),
				'inputClass': 'narrowInput',
				'public': true,
				'displayPos': 2,
				'decimalPlaces': 2
			},
			'effect.entry.bar.type': {
				'tabName':  stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'public': true,
				'displayPos': 0
			},
			'effect.entry.bar.stagger': {
				'tabName':  stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'public': true,
				'displayPos': 1
			},
			'effect.entry.bar.duration': {
				'tabName':  stringResources.get('tabName_animation'),
				'sectionName': stringResources.get('propAniTypeDataEntrance'),
				'sectionPosition': 0,
				'label': stringResources.get('propAniRevealDuration'),
				'ariaLabel': stringResources.get('propAniRevealDuration'),
				'inputClass': 'narrowInput',
				'public': true,
				'displayPos': 2,
				'decimalPlaces': 2
			}
		}
	};
});